<template>
	<el-select remote-show-suffix clearable filterable :style="{ 'width': `${width}` }" :disabled="disabled" :size="size"
		v-model="TypeId" :loading="loading" @focus="SelectFocus" :placeholder="placeholder" @change="TypeChange"
		@clear="TypeClear">
		<el-option v-for="v in AreaTypeList" :key="v[ValueKey]" :label="v[LabelKey]" :value="v[ValueKey]" />
	</el-select>
</template>

<script lang="ts" setup>
import { ref, getCurrentInstance, withDefaults, onMounted, watch } from 'vue';
import translate from '@/api/translate';

interface main {
	id?: string | number,
	size?: string,
	placeholder?: string,
	ValueKey?: string,
	LabelKey?: string,
	width?: string | number,
	disabled?: boolean,
	IsAuto?: boolean,
};

const props = withDefaults(defineProps<main>(), {
	id: "",
	size: "default",
	placeholder: translate.ShowText('请选择'), // 请选择
	ValueKey: "value",
	LabelKey: "label",
	width: "100%",
	disabled: false,
	IsAuto: false,
});

const { proxy } = getCurrentInstance() as any;
const emits = defineEmits(["update:id", "change", "clear"]);
const TypeId = ref<any>("");
const AreaTypeList = ref<any>([]);
const loading = ref(false);

watch(() => props.id, (n: any) => {
	TypeId.value = n;
});

onMounted(() => {
	TypeId.value = props.id;
	if (props.IsAuto) {
		if (proxy.$store.state.AreaTypeList.length > 0) {
			AreaTypeList.value = proxy.$store.state.AreaTypeList;
		} else {
			GetData();
		}
	}
});

const TypeChange = (data: any) => {
	emits("update:id", data);
	emits("change", data);
};
const TypeClear = () => {
	emits("clear");
};
const SelectFocus = () => {
	if (AreaTypeList.value.length == 0 && !props.IsAuto) {
		if (proxy.$store.state.AreaTypeList.length > 0) {
			AreaTypeList.value = proxy.$store.state.AreaTypeList;
		} else {
			GetData();
		}
	}
};
const GetData = () => {
	proxy.$api.tokenRequest({
		url: '/admin/type',
		data: {
			type: 1,
			is_page: 0,
		},
		success: (res: any) => {
			loading.value = false;
			AreaTypeList.value = res.data;
			proxy.$store.commit("GetAllList", {
				type: 4,
				data: res.data,
			});
		},
	});
}
</script>

<style></style>